<template>
  <div class="reply-container" :key="flag">
    <div class="reply-editor-container-full">
      <!--      <div-->
      <!--      :class="{-->
      <!--        'reply-editor-container-full': editorActiveWidth.fullEditor === true,-->
      <!--        'reply-editor-container-big': editorActiveWidth.bigEditor === true,-->
      <!--        'reply-editor-container-small': editorActiveWidth.smallEditor === true-->
      <!--      }"-->
      <!--      @click="onEditorFocus"-->
      <!--    >-->

      <vue-editor
        v-if="mode == 'reply'"
        useCustomImageHandler
        @image-added="handleImageAdded"
        v-model="replyContent"
        :editorOptions="replyEditorSettings"
        :key="componentKeyReplyEditor"
        id="reply-editor-new"
        ref="replyEditor"
      />
<!--      <button @click="handleEditorDropdown('@')" class="btn">@</button>-->
<!--      <button @click="handleEditorDropdown('#')" class="btn">#</button>-->
<!--      <button @click="handleEditorDropdown('TXT')" class="btn">TXT</button>-->
      <!--      <vue-editor-->
      <!--        v-if="mode == 'reply'"-->
      <!--        useCustomImageHandler-->
      <!--        @image-added="handleImageAdded"-->
      <!--        v-model="replyContent"-->
      <!--        :editorOptions="replyEditorSettings"-->
      <!--        :key="componentKeyReplyEditor"-->
      <!--        id="reply-editor"-->
      <!--        ref="replyEditor"-->
      <!--      />-->
      <vue-editor
        v-if="mode == 'reply-email'"
        useCustomImageHandler
        @image-added="handleImageAdded"
        v-model="replyContent"
        :editorOptions="replyEditorSettings"
        :key="componentKeyReplyEditor"
        id="email-editor"
        ref="replyEditor"
      />
    </div>
    <!--    <div-->
    <!--      :class="{-->
    <!--        'reply-container-small': editorActiveWidth.bigEditor === true,-->
    <!--        'reply-container-big': editorActiveWidth.smallEditor === true-->
    <!--      }"-->
    <!--      v-if="taskReplies.length > 0"-->
    <!--    >-->
    <!--      <table-->
    <!--        class="table-sm table-bordered replies-table"-->
    <!--        @click="onRepliesClick()"-->
    <!--      >-->
    <!--        <thead>-->
    <!--          <tr class="bg-primary">-->
    <!--            <th scope="col">Date</th>-->
    <!--            <th scope="col">Time</th>-->
    <!--            <th scope="col">From</th>-->
    <!--            <th scope="col">To</th>-->
    <!--            <th scope="col">Type</th>-->
    <!--            <th scope="col">Process</th>-->
    <!--            <th scope="col">Time</th>-->
    <!--          </tr>-->
    <!--        </thead>-->
    <!--        <tbody>-->
    <!--          <template-->
    <!--            :id="'selectUser-' + record.user.id"-->
    <!--            @click="replyToSpecificUser(record.user.id)"-->
    <!--            v-for="record in taskReplies"-->
    <!--          >-->
    <!--            <tr :key="record.id">-->
    <!--              <td class="td-date">{{ record.updated_at | shortDate }}</td>-->
    <!--              <td class="td-time">{{ record.updated_at | shortTime }}</td>-->
    <!--              <td class="td-from">{{ record.user.full_name }}</td>-->
    <!--              <td class="td-to">{{ getUserReplyTo(record.reply_by) }}</td>-->
    <!--              <td class="td-to">{{ task.task_type.title }}</td>-->
    <!--              <td class="td-process">{{ selectedMainTab }}</td>-->
    <!--              <td class="td-timer">{{ getTimeReply(record.created_at) }}</td>-->
    <!--            </tr>-->
    <!--            <tr :key="record.id + 1">-->
    <!--              <td class="td-content" v-html="record.content" colspan="7"></td>-->
    <!--            </tr>-->
    <!--          </template>-->
    <!--          &lt;!&ndash;          <tr&ndash;&gt;-->
    <!--          &lt;!&ndash;            :id="'selectUser-' + record.user.id" :key="idx"&ndash;&gt;-->
    <!--          &lt;!&ndash;            @click="replyToSpecificUser(record.user.id)" v-for="(record, idx) in&ndash;&gt;-->
    <!--          &lt;!&ndash;            taskReplies" >&ndash;&gt;-->
    <!--          &lt;!&ndash;&lt;!&ndash;          <td colspan="6">&ndash;&gt;&ndash;&gt;-->
    <!--          &lt;!&ndash;&lt;!&ndash;            <table class="table-sm table-bordered replies-table">&ndash;&gt;&ndash;&gt;-->
    <!--          &lt;!&ndash;&lt;!&ndash;              <tr><td class="td-date">{{ record.updated_at | shortDate }}</td>&ndash;&gt;&ndash;&gt;-->
    <!--          &lt;!&ndash;&lt;!&ndash;                <td class="td-time">{{ record.updated_at | shortTime }}</td>&ndash;&gt;&ndash;&gt;-->
    <!--          &lt;!&ndash;&lt;!&ndash;                <td class="td-from">{{ record.user.full_name }}</td>&ndash;&gt;&ndash;&gt;-->
    <!--          &lt;!&ndash;&lt;!&ndash;                <td class="td-content" v-html="record.content"></td>&ndash;&gt;&ndash;&gt;-->
    <!--          &lt;!&ndash;&lt;!&ndash;                <td class="td-process">{{selectedMainTab}}</td>&ndash;&gt;&ndash;&gt;-->
    <!--          &lt;!&ndash;&lt;!&ndash;                <td class="td-timer">@mdo</td></tr>&ndash;&gt;&ndash;&gt;-->
    <!--          &lt;!&ndash;&lt;!&ndash;              <tr >&ndash;&gt;&ndash;&gt;-->
    <!--          &lt;!&ndash;&lt;!&ndash;                <td class="td-content" v-html="record.content" colspan="6"></td>&ndash;&gt;&ndash;&gt;-->
    <!--          &lt;!&ndash;&lt;!&ndash;              </tr>&ndash;&gt;&ndash;&gt;-->
    <!--          &lt;!&ndash;&lt;!&ndash;            </table>&ndash;&gt;&ndash;&gt;-->
    <!--          &lt;!&ndash;&lt;!&ndash;          </td>&ndash;&gt;&ndash;&gt;-->
    <!--          &lt;!&ndash;            <td class="td-date">{{ record.updated_at | shortDate }}</td>&ndash;&gt;-->
    <!--          &lt;!&ndash;            <td class="td-time">{{ record.updated_at | shortTime }}</td>&ndash;&gt;-->
    <!--          &lt;!&ndash;            <td class="td-from">{{ record.user.full_name }}</td>&ndash;&gt;-->
    <!--          &lt;!&ndash;            <td class="td-content" v-html="record.content"></td>&ndash;&gt;-->
    <!--          &lt;!&ndash;            <td class="td-process">{{selectedMainTab}}</td>&ndash;&gt;-->
    <!--          &lt;!&ndash;            <td class="td-timer">@mdo</td>&ndash;&gt;-->

    <!--          &lt;!&ndash;          </tr>&ndash;&gt;-->
    <!--        </tbody>-->
    <!--      </table>-->
    <!--      &lt;!&ndash;      <div class="table-responsive">&ndash;&gt;-->
    <!--      &lt;!&ndash;        &lt;!&ndash;        <table class="table table-condensed">&ndash;&gt;&ndash;&gt;-->
    <!--      &lt;!&ndash;        <table class="table table-condensed reply-table-first">&ndash;&gt;-->
    <!--      &lt;!&ndash;          <tbody id="t-body">&ndash;&gt;-->
    <!--      &lt;!&ndash;            <tr&ndash;&gt;-->
    <!--      &lt;!&ndash;              :id="'selectUser-' + record.user.id"&ndash;&gt;-->
    <!--      &lt;!&ndash;              :key="idx"&ndash;&gt;-->
    <!--      &lt;!&ndash;              @click="replyToSpecificUser(record.user.id)"&ndash;&gt;-->
    <!--      &lt;!&ndash;              v-for="(record, idx) in taskReplies"&ndash;&gt;-->
    <!--      &lt;!&ndash;            >&ndash;&gt;-->
    <!--      &lt;!&ndash;              <td class="reply-user-name">&ndash;&gt;-->
    <!--      &lt;!&ndash;                <img&ndash;&gt;-->
    <!--      &lt;!&ndash;                  :src="record.user.profile_img"&ndash;&gt;-->
    <!--      &lt;!&ndash;                  alt=""&ndash;&gt;-->
    <!--      &lt;!&ndash;                  class="rounded user-img"&ndash;&gt;-->
    <!--      &lt;!&ndash;                />&ndash;&gt;-->
    <!--      &lt;!&ndash;                {{ record.user.full_name }}&ndash;&gt;-->
    <!--      &lt;!&ndash;              </td>&ndash;&gt;-->
    <!--      &lt;!&ndash;              <td class="reply-content-td">&ndash;&gt;-->
    <!--      &lt;!&ndash;                <div&ndash;&gt;-->
    <!--      &lt;!&ndash;                  class="reply-content"&ndash;&gt;-->
    <!--      &lt;!&ndash;                  v-html="record.content"&ndash;&gt;-->
    <!--      &lt;!&ndash;                  :class="record.user.id === auth.user.id ? 'me' : 'him'"&ndash;&gt;-->
    <!--      &lt;!&ndash;                ></div>&ndash;&gt;-->
    <!--      &lt;!&ndash;              </td>&ndash;&gt;-->
    <!--      &lt;!&ndash;              <td class="reply-date-time">&ndash;&gt;-->
    <!--      &lt;!&ndash;                {{ record.updated_at | shortDate }}&ndash;&gt;-->
    <!--      &lt;!&ndash;                {{ record.updated_at | shortTime }}&ndash;&gt;-->
    <!--      &lt;!&ndash;              </td>&ndash;&gt;-->
    <!--      &lt;!&ndash;              <td&ndash;&gt;-->
    <!--      &lt;!&ndash;                :class="{ waitingToBeConfirmed: record.status_id === 6 }"&ndash;&gt;-->
    <!--      &lt;!&ndash;                @click="confirmUser(record)"&ndash;&gt;-->
    <!--      &lt;!&ndash;                v-if="record.status_id === 6"&ndash;&gt;-->
    <!--      &lt;!&ndash;              >&ndash;&gt;-->
    <!--      &lt;!&ndash;                confirm&ndash;&gt;-->
    <!--      &lt;!&ndash;              </td>&ndash;&gt;-->
    <!--      &lt;!&ndash;              &lt;!&ndash;<td >{{ record.status.title }}</td>&ndash;&gt;&ndash;&gt;-->
    <!--      &lt;!&ndash;              <td>&ndash;&gt;-->
    <!--      &lt;!&ndash;                <div class="reply-assignments">&ndash;&gt;-->
    <!--      &lt;!&ndash;                  <span&ndash;&gt;-->
    <!--      &lt;!&ndash;                    :key="idx"&ndash;&gt;-->
    <!--      &lt;!&ndash;                    v-for="(assign, idx) in record.reply_assignment"&ndash;&gt;-->
    <!--      &lt;!&ndash;                    >{{ assign.assigned_to.full_name }},&ndash;&gt;-->
    <!--      &lt;!&ndash;                  </span>&ndash;&gt;-->
    <!--      &lt;!&ndash;                </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;              </td>&ndash;&gt;-->
    <!--      &lt;!&ndash;              <td>&ndash;&gt;-->
    <!--      &lt;!&ndash;                <div class="edit-reply-btn-div">&ndash;&gt;-->
    <!--      &lt;!&ndash;                  <span&ndash;&gt;-->
    <!--      &lt;!&ndash;                    @click="&ndash;&gt;-->
    <!--      &lt;!&ndash;                      reply = record.content;&ndash;&gt;-->
    <!--      &lt;!&ndash;                      inEditTaskOperation = false;&ndash;&gt;-->
    <!--      &lt;!&ndash;                      inEditReplyOperation = true;&ndash;&gt;-->
    <!--      &lt;!&ndash;                      selectedReplyIdToUpdate = record.id;&ndash;&gt;-->
    <!--      &lt;!&ndash;                    "&ndash;&gt;-->
    <!--      &lt;!&ndash;                    class="edit-reply-btn-edit"&ndash;&gt;-->
    <!--      &lt;!&ndash;                    v-if="&ndash;&gt;-->
    <!--      &lt;!&ndash;                      record.user.id === auth.user.id || auth.user.role === 1&ndash;&gt;-->
    <!--      &lt;!&ndash;                    "&ndash;&gt;-->
    <!--      &lt;!&ndash;                    ><svg&ndash;&gt;-->
    <!--      &lt;!&ndash;                      height="14pt"&ndash;&gt;-->
    <!--      &lt;!&ndash;                      viewBox="0 -1 401.5411 401"&ndash;&gt;-->
    <!--      &lt;!&ndash;                      width="14pt"&ndash;&gt;-->
    <!--      &lt;!&ndash;                      xmlns="http://www.w3.org/2000/svg"&ndash;&gt;-->
    <!--      &lt;!&ndash;                    >&ndash;&gt;-->
    <!--      &lt;!&ndash;                      <path&ndash;&gt;-->
    <!--      &lt;!&ndash;                        d="m381.289062 32.242188c13.671876 13.664062 13.671876 35.824218 0 49.488281l-17.679687 17.679687-61.230469-61.230468 17.679688-17.679688c13.671875-13.667969 35.832031-13.667969 49.5 0zm0 0"&ndash;&gt;-->
    <!--      &lt;!&ndash;                        fill="#00acea"&ndash;&gt;-->
    <!--      &lt;!&ndash;                      />&ndash;&gt;-->
    <!--      &lt;!&ndash;                      <path&ndash;&gt;-->
    <!--      &lt;!&ndash;                        d="m363.609375 99.410156-160.148437 160.160156h-.011719l-61.230469-61.230468 160.160156-160.160156zm0 0"&ndash;&gt;-->
    <!--      &lt;!&ndash;                        fill="#00efd1"&ndash;&gt;-->
    <!--      &lt;!&ndash;                      />&ndash;&gt;-->
    <!--      &lt;!&ndash;                      <path&ndash;&gt;-->
    <!--      &lt;!&ndash;                        d="m142.21875 198.339844 61.230469 61.230468-.570313.570313-84.6875 23.460937 23.457032-84.691406zm0 0"&ndash;&gt;-->
    <!--      &lt;!&ndash;                        fill="#fedb41"&ndash;&gt;-->
    <!--      &lt;!&ndash;                      />&ndash;&gt;-->
    <!--      &lt;!&ndash;                      <g fill="#083863">&ndash;&gt;-->
    <!--      &lt;!&ndash;                        <path&ndash;&gt;-->
    <!--      &lt;!&ndash;                          d="m370.589844 250.960938c-5.523438 0-10 4.476562-10 10v88.789062c-.019532 16.5625-13.4375 29.980469-30 30h-280.589844c-16.5625-.019531-29.980469-13.4375-30-30v-260.589844c.019531-16.558594 13.4375-29.980468 30-30h88.789062c5.523438 0 10-4.476562 10-10 0-5.523437-4.476562-10-10-10h-88.789062c-27.601562.03125-49.96875 22.398438-50 50v260.589844c.03125 27.601562 22.398438 49.96875 50 50h280.589844c27.601562-.03125 49.96875-22.398438 50-50v-88.789062c0-5.523438-4.476563-10-10-10zm0 0"&ndash;&gt;-->
    <!--      &lt;!&ndash;                        />&ndash;&gt;-->
    <!--      &lt;!&ndash;                        <path&ndash;&gt;-->
    <!--      &lt;!&ndash;                          d="m376.632812 13.429688c-17.589843-17.546876-46.058593-17.546876-63.644531 0l-178.410156 178.410156c-1.21875 1.222656-2.105469 2.738281-2.566406 4.398437l-23.457031 84.691407c-.964844 3.472656.015624 7.191406 2.5625 9.742187 2.550781 2.546875 6.269531 3.527344 9.742187 2.566406l84.691406-23.460937c1.664063-.460938 3.183594-1.347656 4.40625-2.570313l.566407-.570312 177.835937-177.835938c17.574219-17.570312 17.574219-46.058593 0-63.628906zm-229.675781 203.789062 37.613281 37.617188-52.03125 14.414062zm56.5 42.355469v-.007813l6.519531 6.519532zm0-14.140625-47.09375-47.09375 146.015625-146.015625 47.089844 47.085937zm170.761719-170.773438-10.609375 10.609375-47.085937-47.089843 10.609374-10.609376c9.765626-9.746093 25.582032-9.746093 35.351563 0l11.734375 11.746094c9.765625 9.757813 9.765625 25.585938 0 35.34375zm0 0"&ndash;&gt;-->
    <!--      &lt;!&ndash;                        />&ndash;&gt;-->
    <!--      &lt;!&ndash;                      </g></svg&ndash;&gt;-->
    <!--      &lt;!&ndash;                  ></span>&ndash;&gt;-->
    <!--      &lt;!&ndash;                  <div class="floating-wrapper">&ndash;&gt;-->
    <!--      &lt;!&ndash;                    <reply-edit-log&ndash;&gt;-->
    <!--      &lt;!&ndash;                      :log="record.reply_edit_log"&ndash;&gt;-->
    <!--      &lt;!&ndash;                      v-if="record.user.id === auth.user.id"&ndash;&gt;-->
    <!--      &lt;!&ndash;                    ></reply-edit-log>&ndash;&gt;-->
    <!--      &lt;!&ndash;                  </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;                </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;              </td>&ndash;&gt;-->
    <!--      &lt;!&ndash;            </tr>&ndash;&gt;-->
    <!--      &lt;!&ndash;          </tbody>&ndash;&gt;-->
    <!--      &lt;!&ndash;        </table>&ndash;&gt;-->
    <!--      &lt;!&ndash;      </div>&ndash;&gt;-->
    <!--    </div>-->
    <!--End of waiting confirmation users-->

    <!--    <div class="reply-table-inner-bottom" v-if="checkOwnership()">-->
    <!--      <div class="table-responsive">-->
    <!--        <table class="table">-->
    <!--          <tbody>-->
    <!--            Click once to select who to send reply, click again to un-select. If-->
    <!--            none is selected, the reply will be sent to all of them.-->
    <!--            <tr-->
    <!--              :id="'selectUser-' + user.assigned_to.id"-->
    <!--              :key="index"-->
    <!--              @click="replyToSpecificUser(user.assigned_to.id)"-->
    <!--              v-for="(user, index) in this.task.task_assignment"-->
    <!--            >-->
    <!--              <td class="td-center">-->
    <!--                {{ user.assigned_to.full_name }}-->
    <!--              </td>-->
    <!--            </tr>-->
    <!--            <tr-->
    <!--              v-if="task.task_check.length > 0"-->
    <!--              style="background-color: #5daeda"-->
    <!--            >-->
    <!--              <td class="td-center">-->
    <!--                {{ showLineThatItHasWaitingCheck() }}-->
    <!--              </td>-->
    <!--            </tr>-->
    <!--          </tbody>-->
    <!--        </table>-->
    <!--      </div>-->
    <!--    </div>-->
    <div id="imgModalReply" class="modal">
      <span class="close-img-modal">&times;</span>
      <img class="modal-content" id="imgReply" />
    </div>
    <!--    <div class="task-content-preview" v-html="task.content"></div>-->
    <TaskVideoRec
      class="forRec"
      v-if="turnOnRec"
      @videoRec="sendRec"
      @closeRec="closeRecDiv"
    ></TaskVideoRec>
  </div>
  <!--  <div v-else class="reply-container" :key="flag">-->
  <!--    <div-->
  <!--            :class="{-->
  <!--        'reply-container-small': editorActiveWidth.bigEditor === true,-->
  <!--        'reply-container-big': editorActiveWidth.smallEditor === true-->
  <!--      }"-->
  <!--            v-if="taskReplies.length > 0"-->
  <!--    >-->
  <!--      <table-->
  <!--              class="table-sm table-bordered replies-table"-->
  <!--              @click="onRepliesClick()"-->
  <!--      >-->
  <!--        <thead>-->
  <!--        <tr class="bg-primary">-->
  <!--          <th scope="col">Date</th>-->
  <!--          <th scope="col">Time</th>-->
  <!--          <th scope="col">From</th>-->
  <!--          <th scope="col">To</th>-->
  <!--          <th scope="col">Type</th>-->
  <!--          <th scope="col">Process</th>-->
  <!--          <th scope="col">Time</th>-->
  <!--        </tr>-->
  <!--        </thead>-->
  <!--        <tbody>-->
  <!--        <template-->
  <!--                :id="'selectUser-' + record.user.id"-->
  <!--                @click="replyToSpecificUser(record.user.id)"-->
  <!--                v-for="record in taskReplies"-->
  <!--        >-->
  <!--          <tr :key="record.id">-->
  <!--            <td class="td-date">{{ record.updated_at | shortDate }}</td>-->
  <!--            <td class="td-time">{{ record.updated_at | shortTime }}</td>-->
  <!--            <td class="td-from">{{ record.user.full_name }}</td>-->
  <!--            <td class="td-to">{{ getUserReplyTo(record.reply_by) }}</td>-->
  <!--            <td class="td-to">{{ task.task_type.title }}</td>-->
  <!--            <td class="td-process">{{ selectedMainTab }}</td>-->
  <!--            <td class="td-timer">{{ getTimeReply(record.created_at) }}</td>-->
  <!--          </tr>-->
  <!--          <tr :key="record.id + 1">-->
  <!--            <td class="td-content" v-html="record.content" colspan="7"></td>-->
  <!--          </tr>-->
  <!--        </template>-->
  <!--        &lt;!&ndash;          <tr&ndash;&gt;-->
  <!--        &lt;!&ndash;            :id="'selectUser-' + record.user.id" :key="idx"&ndash;&gt;-->
  <!--        &lt;!&ndash;            @click="replyToSpecificUser(record.user.id)" v-for="(record, idx) in&ndash;&gt;-->
  <!--        &lt;!&ndash;            taskReplies" >&ndash;&gt;-->
  <!--        &lt;!&ndash;&lt;!&ndash;          <td colspan="6">&ndash;&gt;&ndash;&gt;-->
  <!--        &lt;!&ndash;&lt;!&ndash;            <table class="table-sm table-bordered replies-table">&ndash;&gt;&ndash;&gt;-->
  <!--        &lt;!&ndash;&lt;!&ndash;              <tr><td class="td-date">{{ record.updated_at | shortDate }}</td>&ndash;&gt;&ndash;&gt;-->
  <!--        &lt;!&ndash;&lt;!&ndash;                <td class="td-time">{{ record.updated_at | shortTime }}</td>&ndash;&gt;&ndash;&gt;-->
  <!--        &lt;!&ndash;&lt;!&ndash;                <td class="td-from">{{ record.user.full_name }}</td>&ndash;&gt;&ndash;&gt;-->
  <!--        &lt;!&ndash;&lt;!&ndash;                <td class="td-content" v-html="record.content"></td>&ndash;&gt;&ndash;&gt;-->
  <!--        &lt;!&ndash;&lt;!&ndash;                <td class="td-process">{{selectedMainTab}}</td>&ndash;&gt;&ndash;&gt;-->
  <!--        &lt;!&ndash;&lt;!&ndash;                <td class="td-timer">@mdo</td></tr>&ndash;&gt;&ndash;&gt;-->
  <!--        &lt;!&ndash;&lt;!&ndash;              <tr >&ndash;&gt;&ndash;&gt;-->
  <!--        &lt;!&ndash;&lt;!&ndash;                <td class="td-content" v-html="record.content" colspan="6"></td>&ndash;&gt;&ndash;&gt;-->
  <!--        &lt;!&ndash;&lt;!&ndash;              </tr>&ndash;&gt;&ndash;&gt;-->
  <!--        &lt;!&ndash;&lt;!&ndash;            </table>&ndash;&gt;&ndash;&gt;-->
  <!--        &lt;!&ndash;&lt;!&ndash;          </td>&ndash;&gt;&ndash;&gt;-->
  <!--        &lt;!&ndash;            <td class="td-date">{{ record.updated_at | shortDate }}</td>&ndash;&gt;-->
  <!--        &lt;!&ndash;            <td class="td-time">{{ record.updated_at | shortTime }}</td>&ndash;&gt;-->
  <!--        &lt;!&ndash;            <td class="td-from">{{ record.user.full_name }}</td>&ndash;&gt;-->
  <!--        &lt;!&ndash;            <td class="td-content" v-html="record.content"></td>&ndash;&gt;-->
  <!--        &lt;!&ndash;            <td class="td-process">{{selectedMainTab}}</td>&ndash;&gt;-->
  <!--        &lt;!&ndash;            <td class="td-timer">@mdo</td>&ndash;&gt;-->

  <!--        &lt;!&ndash;          </tr>&ndash;&gt;-->
  <!--        </tbody>-->
  <!--      </table>-->
  <!--      &lt;!&ndash;      <div class="table-responsive">&ndash;&gt;-->
  <!--      &lt;!&ndash;        &lt;!&ndash;        <table class="table table-condensed">&ndash;&gt;&ndash;&gt;-->
  <!--      &lt;!&ndash;        <table class="table table-condensed reply-table-first">&ndash;&gt;-->
  <!--      &lt;!&ndash;          <tbody id="t-body">&ndash;&gt;-->
  <!--      &lt;!&ndash;            <tr&ndash;&gt;-->
  <!--      &lt;!&ndash;              :id="'selectUser-' + record.user.id"&ndash;&gt;-->
  <!--      &lt;!&ndash;              :key="idx"&ndash;&gt;-->
  <!--      &lt;!&ndash;              @click="replyToSpecificUser(record.user.id)"&ndash;&gt;-->
  <!--      &lt;!&ndash;              v-for="(record, idx) in taskReplies"&ndash;&gt;-->
  <!--      &lt;!&ndash;            >&ndash;&gt;-->
  <!--      &lt;!&ndash;              <td class="reply-user-name">&ndash;&gt;-->
  <!--      &lt;!&ndash;                <img&ndash;&gt;-->
  <!--      &lt;!&ndash;                  :src="record.user.profile_img"&ndash;&gt;-->
  <!--      &lt;!&ndash;                  alt=""&ndash;&gt;-->
  <!--      &lt;!&ndash;                  class="rounded user-img"&ndash;&gt;-->
  <!--      &lt;!&ndash;                />&ndash;&gt;-->
  <!--      &lt;!&ndash;                {{ record.user.full_name }}&ndash;&gt;-->
  <!--      &lt;!&ndash;              </td>&ndash;&gt;-->
  <!--      &lt;!&ndash;              <td class="reply-content-td">&ndash;&gt;-->
  <!--      &lt;!&ndash;                <div&ndash;&gt;-->
  <!--      &lt;!&ndash;                  class="reply-content"&ndash;&gt;-->
  <!--      &lt;!&ndash;                  v-html="record.content"&ndash;&gt;-->
  <!--      &lt;!&ndash;                  :class="record.user.id === auth.user.id ? 'me' : 'him'"&ndash;&gt;-->
  <!--      &lt;!&ndash;                ></div>&ndash;&gt;-->
  <!--      &lt;!&ndash;              </td>&ndash;&gt;-->
  <!--      &lt;!&ndash;              <td class="reply-date-time">&ndash;&gt;-->
  <!--      &lt;!&ndash;                {{ record.updated_at | shortDate }}&ndash;&gt;-->
  <!--      &lt;!&ndash;                {{ record.updated_at | shortTime }}&ndash;&gt;-->
  <!--      &lt;!&ndash;              </td>&ndash;&gt;-->
  <!--      &lt;!&ndash;              <td&ndash;&gt;-->
  <!--      &lt;!&ndash;                :class="{ waitingToBeConfirmed: record.status_id === 6 }"&ndash;&gt;-->
  <!--      &lt;!&ndash;                @click="confirmUser(record)"&ndash;&gt;-->
  <!--      &lt;!&ndash;                v-if="record.status_id === 6"&ndash;&gt;-->
  <!--      &lt;!&ndash;              >&ndash;&gt;-->
  <!--      &lt;!&ndash;                confirm&ndash;&gt;-->
  <!--      &lt;!&ndash;              </td>&ndash;&gt;-->
  <!--      &lt;!&ndash;              &lt;!&ndash;<td >{{ record.status.title }}</td>&ndash;&gt;&ndash;&gt;-->
  <!--      &lt;!&ndash;              <td>&ndash;&gt;-->
  <!--      &lt;!&ndash;                <div class="reply-assignments">&ndash;&gt;-->
  <!--      &lt;!&ndash;                  <span&ndash;&gt;-->
  <!--      &lt;!&ndash;                    :key="idx"&ndash;&gt;-->
  <!--      &lt;!&ndash;                    v-for="(assign, idx) in record.reply_assignment"&ndash;&gt;-->
  <!--      &lt;!&ndash;                    >{{ assign.assigned_to.full_name }},&ndash;&gt;-->
  <!--      &lt;!&ndash;                  </span>&ndash;&gt;-->
  <!--      &lt;!&ndash;                </div>&ndash;&gt;-->
  <!--      &lt;!&ndash;              </td>&ndash;&gt;-->
  <!--      &lt;!&ndash;              <td>&ndash;&gt;-->
  <!--      &lt;!&ndash;                <div class="edit-reply-btn-div">&ndash;&gt;-->
  <!--      &lt;!&ndash;                  <span&ndash;&gt;-->
  <!--      &lt;!&ndash;                    @click="&ndash;&gt;-->
  <!--      &lt;!&ndash;                      reply = record.content;&ndash;&gt;-->
  <!--      &lt;!&ndash;                      inEditTaskOperation = false;&ndash;&gt;-->
  <!--      &lt;!&ndash;                      inEditReplyOperation = true;&ndash;&gt;-->
  <!--      &lt;!&ndash;                      selectedReplyIdToUpdate = record.id;&ndash;&gt;-->
  <!--      &lt;!&ndash;                    "&ndash;&gt;-->
  <!--      &lt;!&ndash;                    class="edit-reply-btn-edit"&ndash;&gt;-->
  <!--      &lt;!&ndash;                    v-if="&ndash;&gt;-->
  <!--      &lt;!&ndash;                      record.user.id === auth.user.id || auth.user.role === 1&ndash;&gt;-->
  <!--      &lt;!&ndash;                    "&ndash;&gt;-->
  <!--      &lt;!&ndash;                    ><svg&ndash;&gt;-->
  <!--      &lt;!&ndash;                      height="14pt"&ndash;&gt;-->
  <!--      &lt;!&ndash;                      viewBox="0 -1 401.5411 401"&ndash;&gt;-->
  <!--      &lt;!&ndash;                      width="14pt"&ndash;&gt;-->
  <!--      &lt;!&ndash;                      xmlns="http://www.w3.org/2000/svg"&ndash;&gt;-->
  <!--      &lt;!&ndash;                    >&ndash;&gt;-->
  <!--      &lt;!&ndash;                      <path&ndash;&gt;-->
  <!--      &lt;!&ndash;                        d="m381.289062 32.242188c13.671876 13.664062 13.671876 35.824218 0 49.488281l-17.679687 17.679687-61.230469-61.230468 17.679688-17.679688c13.671875-13.667969 35.832031-13.667969 49.5 0zm0 0"&ndash;&gt;-->
  <!--      &lt;!&ndash;                        fill="#00acea"&ndash;&gt;-->
  <!--      &lt;!&ndash;                      />&ndash;&gt;-->
  <!--      &lt;!&ndash;                      <path&ndash;&gt;-->
  <!--      &lt;!&ndash;                        d="m363.609375 99.410156-160.148437 160.160156h-.011719l-61.230469-61.230468 160.160156-160.160156zm0 0"&ndash;&gt;-->
  <!--      &lt;!&ndash;                        fill="#00efd1"&ndash;&gt;-->
  <!--      &lt;!&ndash;                      />&ndash;&gt;-->
  <!--      &lt;!&ndash;                      <path&ndash;&gt;-->
  <!--      &lt;!&ndash;                        d="m142.21875 198.339844 61.230469 61.230468-.570313.570313-84.6875 23.460937 23.457032-84.691406zm0 0"&ndash;&gt;-->
  <!--      &lt;!&ndash;                        fill="#fedb41"&ndash;&gt;-->
  <!--      &lt;!&ndash;                      />&ndash;&gt;-->
  <!--      &lt;!&ndash;                      <g fill="#083863">&ndash;&gt;-->
  <!--      &lt;!&ndash;                        <path&ndash;&gt;-->
  <!--      &lt;!&ndash;                          d="m370.589844 250.960938c-5.523438 0-10 4.476562-10 10v88.789062c-.019532 16.5625-13.4375 29.980469-30 30h-280.589844c-16.5625-.019531-29.980469-13.4375-30-30v-260.589844c.019531-16.558594 13.4375-29.980468 30-30h88.789062c5.523438 0 10-4.476562 10-10 0-5.523437-4.476562-10-10-10h-88.789062c-27.601562.03125-49.96875 22.398438-50 50v260.589844c.03125 27.601562 22.398438 49.96875 50 50h280.589844c27.601562-.03125 49.96875-22.398438 50-50v-88.789062c0-5.523438-4.476563-10-10-10zm0 0"&ndash;&gt;-->
  <!--      &lt;!&ndash;                        />&ndash;&gt;-->
  <!--      &lt;!&ndash;                        <path&ndash;&gt;-->
  <!--      &lt;!&ndash;                          d="m376.632812 13.429688c-17.589843-17.546876-46.058593-17.546876-63.644531 0l-178.410156 178.410156c-1.21875 1.222656-2.105469 2.738281-2.566406 4.398437l-23.457031 84.691407c-.964844 3.472656.015624 7.191406 2.5625 9.742187 2.550781 2.546875 6.269531 3.527344 9.742187 2.566406l84.691406-23.460937c1.664063-.460938 3.183594-1.347656 4.40625-2.570313l.566407-.570312 177.835937-177.835938c17.574219-17.570312 17.574219-46.058593 0-63.628906zm-229.675781 203.789062 37.613281 37.617188-52.03125 14.414062zm56.5 42.355469v-.007813l6.519531 6.519532zm0-14.140625-47.09375-47.09375 146.015625-146.015625 47.089844 47.085937zm170.761719-170.773438-10.609375 10.609375-47.085937-47.089843 10.609374-10.609376c9.765626-9.746093 25.582032-9.746093 35.351563 0l11.734375 11.746094c9.765625 9.757813 9.765625 25.585938 0 35.34375zm0 0"&ndash;&gt;-->
  <!--      &lt;!&ndash;                        />&ndash;&gt;-->
  <!--      &lt;!&ndash;                      </g></svg&ndash;&gt;-->
  <!--      &lt;!&ndash;                  ></span>&ndash;&gt;-->
  <!--      &lt;!&ndash;                  <div class="floating-wrapper">&ndash;&gt;-->
  <!--      &lt;!&ndash;                    <reply-edit-log&ndash;&gt;-->
  <!--      &lt;!&ndash;                      :log="record.reply_edit_log"&ndash;&gt;-->
  <!--      &lt;!&ndash;                      v-if="record.user.id === auth.user.id"&ndash;&gt;-->
  <!--      &lt;!&ndash;                    ></reply-edit-log>&ndash;&gt;-->
  <!--      &lt;!&ndash;                  </div>&ndash;&gt;-->
  <!--      &lt;!&ndash;                </div>&ndash;&gt;-->
  <!--      &lt;!&ndash;              </td>&ndash;&gt;-->
  <!--      &lt;!&ndash;            </tr>&ndash;&gt;-->
  <!--      &lt;!&ndash;          </tbody>&ndash;&gt;-->
  <!--      &lt;!&ndash;        </table>&ndash;&gt;-->
  <!--      &lt;!&ndash;      </div>&ndash;&gt;-->
  <!--    </div>-->
  <!--    &lt;!&ndash;End of waiting confirmation users&ndash;&gt;-->

  <!--    &lt;!&ndash;    <div class="reply-table-inner-bottom" v-if="checkOwnership()">&ndash;&gt;-->
  <!--    &lt;!&ndash;      <div class="table-responsive">&ndash;&gt;-->
  <!--    &lt;!&ndash;        <table class="table">&ndash;&gt;-->
  <!--    &lt;!&ndash;          <tbody>&ndash;&gt;-->
  <!--    &lt;!&ndash;            Click once to select who to send reply, click again to un-select. If&ndash;&gt;-->
  <!--    &lt;!&ndash;            none is selected, the reply will be sent to all of them.&ndash;&gt;-->
  <!--    &lt;!&ndash;            <tr&ndash;&gt;-->
  <!--    &lt;!&ndash;              :id="'selectUser-' + user.assigned_to.id"&ndash;&gt;-->
  <!--    &lt;!&ndash;              :key="index"&ndash;&gt;-->
  <!--    &lt;!&ndash;              @click="replyToSpecificUser(user.assigned_to.id)"&ndash;&gt;-->
  <!--    &lt;!&ndash;              v-for="(user, index) in this.task.task_assignment"&ndash;&gt;-->
  <!--    &lt;!&ndash;            >&ndash;&gt;-->
  <!--    &lt;!&ndash;              <td class="td-center">&ndash;&gt;-->
  <!--    &lt;!&ndash;                {{ user.assigned_to.full_name }}&ndash;&gt;-->
  <!--    &lt;!&ndash;              </td>&ndash;&gt;-->
  <!--    &lt;!&ndash;            </tr>&ndash;&gt;-->
  <!--    &lt;!&ndash;            <tr&ndash;&gt;-->
  <!--    &lt;!&ndash;              v-if="task.task_check.length > 0"&ndash;&gt;-->
  <!--    &lt;!&ndash;              style="background-color: #5daeda"&ndash;&gt;-->
  <!--    &lt;!&ndash;            >&ndash;&gt;-->
  <!--    &lt;!&ndash;              <td class="td-center">&ndash;&gt;-->
  <!--    &lt;!&ndash;                {{ showLineThatItHasWaitingCheck() }}&ndash;&gt;-->
  <!--    &lt;!&ndash;              </td>&ndash;&gt;-->
  <!--    &lt;!&ndash;            </tr>&ndash;&gt;-->
  <!--    &lt;!&ndash;          </tbody>&ndash;&gt;-->
  <!--    &lt;!&ndash;        </table>&ndash;&gt;-->
  <!--    &lt;!&ndash;      </div>&ndash;&gt;-->
  <!--    &lt;!&ndash;    </div>&ndash;&gt;-->
  <!--    <div id="imgModalReply" class="modal">-->
  <!--      <span class="close-img-modal">&times;</span>-->
  <!--      <img class="modal-content" id="imgReply" />-->
  <!--    </div>-->
  <!--    &lt;!&ndash;    <div class="task-content-preview" v-html="task.content"></div>&ndash;&gt;-->
  <!--    <TaskVideoRec-->
  <!--            class="forRec"-->
  <!--            v-if="turnOnRec"-->
  <!--            @videoRec="sendRec"-->
  <!--            @closeRec="closeRecDiv"-->
  <!--    ></TaskVideoRec>-->
  <!--  </div>-->
</template>

<script>
import apiClientCreator from "../../../helpers/api/request";
import vClickOutside from "v-click-outside";
import { VueEditor, Quill } from "vue2-editor";
// import { VueEditor, Quill } from "../components/vue2-editor";
import ReplyEditLog from "./ReplyEditLog";
import UsersActiveScope from "../../company.feature/sub_features.company/clients_table.sub_feature.company/mixins/UsersActiveScope";
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment";
import TaskModel from "./TaskModel";
import QuillMention from "./q-mention/src/quill.mention";
import ImageResize from "quill-image-resize-vue";
import TaskVideoRec from "../components/TaskVideoRec";
import SocketEndpoints from "@/mixins/system/SocketEndpoints";

Quill.register("modules/imageResize", ImageResize);
Quill.register("modules/QuillMention", QuillMention);
export default {
  name: "MainTaskWindowReply.component",
  mixins: [UsersActiveScope, SocketEndpoints],
  components: {
    // ReplyEditLog,
    VueEditor,
    TaskVideoRec
  },
  props: {
    notApprovedStarRating: {
      type: String
    },
    task: {
      type: Object,
      required: true
    },
    categoriesOfTask: {
      type: Array
    },
    // handleImageAdded: {
    //   type: Function,
    //   required: true
    // },
    replyContent: {
      type: String,
      required: true,
    },
    selectedMainTab: {
      type: String,
      required: true
    },
    hashValues: {
      type: Array,
      default: () => []
    },
    assignReplyTo: {
      type: Array,
      default: () => []
    },
    replyStatus: {
      type: Array,
      default: () => ({
        id: 1,
        type: "REPLY",
        title: "Replied"
      })
    },
    editorSettings: {
      type: Array
    },
    mode: {
      type: String,
      required: true
    },
    taskUsersTalking: {
      type: Array,
      required: true
    },
    replyUsers: {
      type: Array
    },
    selectedReplyIdToUpdate: {
      type: Number
    }
  },
  data() {
    return {
      // replyUsers:[],
      // taskUsersTalking: [],
      fileMaxSize: 4194304,
      turnOnRec: false,
      componentKeyReplyEditor: 0,
      CheckIfAllReplied: false,
      creatorHasConfirmedTheTask: false,
      categoriesForMention: [],

      //selectUserRowStyle: "select-user",

      showPopup: false,
      showBtnBar: false,
      content: this.task.content,
      // hashValues: [],
      showPencil: false,
      showEditTaskText: false,
      showEditTask: false,
      showReplyTaskText: false,
      // reply: null,
      showReply: false,
      taskReplies: [],
      taskRepliesForCheck: [],
      showFullContent: false,
      userConfirmed: false,
      showReplyPopup: false,
      isImgModalOpened: false,
      editorActiveWidth: {
        // full: this.taskReplies.length == 0 ? true : false,
        // big: this.taskReplies.length > 0 ? true : false,
        // small:false
      },
      badWordsArray: [
        "#",
        "anal",
        "anus",
        "arse",
        "ass",
        "ballsack",
        "balls",
        "bastard",
        "bitch",
        "biatch",
        "bloody",
        "blowjob",
        "bollock",
        "bollok",
        "boner",
        "boob",
        "bugger",
        "bum",
        "butt",
        "buttplug",
        "clitoris",
        "cock",
        "coon",
        "crap",
        "cunt",
        "damn",
        "dick",
        "dildo",
        "dyke",
        "fag",
        "feck",
        "fellate",
        "fellatio",
        "felching",
        "fuck",
        "fudgepacker",
        "flange",
        "goddamn",
        "hell",
        "homo",
        "jizz",
        "knobend",
        "labia",
        "muff",
        "nigger",
        "nigga",
        "jude",
        "penis",
        "piss",
        "poop",
        "prick",
        "pube",
        "pussy",
        "queer",
        "scrotum",
        "sex",
        "shit",
        "sh1t",
        "slut",
        "smegma",
        "spunk",
        "suck",
        "tit",
        "tosser",
        "turd",
        "twat",
        "vagina",
        "wank",
        "whore",
        "wtf"
      ],
      inEditReplyOperation: false,
      inEditTaskOperation: false,
      // selectedReplyIdToUpdate: null,
      updatedReply: null,
      replyToSpecificUsers: [],
      remainingToBeConfirmed: null,
      replyCategories: [],
      transferToUsersList: null,
      showTransferToUsersResults: false,
      searchTransferToUserNameQuery: null,
      searchTransferToUserNameQueryResult: [],
      transferToThisUser: [],
      transferredTasks: [],
      transferToButtonText: "TRANSFER TASK TO",
      transferTaskTo: false,
      timerLog: [],
      replyMode: false,
      // mode: "reply",
      selectedTaskTabForReply: "TASK",
      // replyContent: "",
      flag: 0,
      replyEditorSettings: {
        modules: {
          toolbar: {
            container: [
              [{ header: [false, 1, 2, 3, 4, 5, 6] }],
              ["bold", "italic", "underline"], // toggled buttons
              [{ align: "" }, { align: "right" }, { align: "justify" }],
              ["blockquote"],
              [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
              // [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
              [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              ["link", "image", "video"]
              // ["clean"] // remove formatting button
            ],
            handlers: {
              video: () => {
                // just give your custom elements a class like "ql-customThingy" and the handlers will just work
              },
              redo: () => {}
            }
          },
          imageResize: { displaySize: true },
          mention: {
            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
            showDenotationChar: this.mode === "reply-email" ? false : true,
            mentionDenotationChars: [
              " ",
              "@",
              "#",
              "anal",
              "anus",
              "arse",
              "ass",
              "ballsack",
              "balls",
              "bastard",
              "bitch",
              "biatch",
              "bloody",
              "blowjob",
              "bollock",
              "bollok",
              "boner",
              "boob",
              "bugger",
              "bum",
              "butt",
              "buttplug",
              "clitoris",
              "cock",
              "coon",
              "crap",
              "cunt",
              "damn",
              "dick",
              "dildo",
              "dyke",
              "fag",
              "feck",
              "fellate",
              "fellatio",
              "felching",
              "fuck",
              "fudgepacker",
              "flange",
              "goddamn",
              "hell",
              "homo",
              "jizz",
              "knobend",
              "labia",
              "muff",
              "nigger",
              "nigga",
              "jude",
              "penis",
              "piss",
              "poop",
              "prick",
              "pube",
              "pussy",
              "queer",
              "scrotum",
              "sex",
              "shit",
              "sh1t",
              "slut",
              "smegma",
              "spunk",
              "suck",
              "tit",
              "tosser",
              "turd",
              "twat",
              "vagina",
              "wank",
              "whore",
              "wtf"
            ],
            defaultMenuOrientation: "top",
            // offsetTop: 0,
            // offsetLeft:2,
            source: (searchTerm, renderList, mentionChar) => {
              let values;
              // let x = mentionChar.toLowerCase()
              if (mentionChar === "#") {
                values = this.hashValues;
                if (searchTerm.length === 0) {
                  renderList(values, searchTerm);
                } else {
                  const matches = [];
                  for (let i = 0; i < values.length; i++)
                    if (
                      ~values[i].value
                        .toLowerCase()
                        .indexOf(searchTerm.toLowerCase())
                    )
                      matches.push(values[i]);
                  if (matches.length > 0) {
                    renderList(matches, searchTerm);
                  } else {
                    let tempTag = {
                      denotationChar: "#",
                      id: "777",
                      index: "123",
                      value: searchTerm
                    };
                    matches.push(tempTag);
                    renderList(matches, searchTerm);
                  }
                }
              } else if (mentionChar === "@") {
                values = this.taskUsersTalking;
                if (searchTerm.length === 0) {
                  renderList(values, searchTerm);
                } else {
                  const matches = [];
                  for (let i = 0; i < values.length; i++)
                    if (
                      ~values[i].value
                        .toLowerCase()
                        .indexOf(searchTerm.toLowerCase())
                    )
                      matches.push(values[i]);
                  if (matches.length > 0) {
                    renderList(matches, searchTerm);
                  } else {
                    let tempTag = {
                      denotationChar: "#",
                      id: "777",
                      index: "123",
                      value: searchTerm
                    };
                    matches.push(tempTag);
                    renderList(matches, searchTerm);
                  }
                }
              } else {
                setTimeout(() => {
                  // this.textValidation(this.replyContent);
                }, 1000);
                mentionChar = null;
              }
            },
            onOpen: () => {},
            onSelect: async (item, insertItem) => {
              if (item.denotationChar === "#") {
                await this.addNewTagFromEditor(item.value);
                insertItem(item);
                let tempCategory = this.categoriesForMention.filter(
                  category => {
                    return category.value == item.value;
                  }
                );
                if (
                  !this.categoriesOfTask.some(category => {
                    //          checks if category already in array
                    return category.value == tempCategory[0].value;
                  })
                ) {
                  this.categoriesOfTask.push(tempCategory[0]);
                  this.replyCategories.push(tempCategory[0].code.id); // insert category from editor to new task object
                  this.$emit("addedTagFromReply");
                }

                this.componentKeyTags += 1;
              } else if (item.denotationChar === "@") {
                insertItem(item);
                let selectedUser = this.salesPersonList.find(
                  user => user.id == item.id
                );
                this.replyUsers.push(selectedUser.id);
                // this.subTasks[
                //   `subTask_${subTask_id}`
                // ].subTaskUserAssignment.push(subTaskUser);
              }
            }
          }
        },
        disabled: true
      }
    };
  },

  directives: {
    clickOutside: vClickOutside.directive
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "loading"
    ]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"]),
    ...mapState("tasks", [
      "tasks",
      "activeTasks",
      "allActiveTasks",
      "taskDictionaries",
      "categories"
    ]),
    ...mapGetters("tasks", ["getTasks", "getActiveTasks", "getAllActiveTasks"])

    // getEditorClass() {
    //   this.flag += 1;
    //   if (this.editorActiveWidth.fullEditor === true) {
    //     return "reply-editor-container-full";
    //   } else if (this.editorActiveWidth.bigEditor === true) {
    //     return "reply-editor-container-big";
    //   } else if (this.editorActiveWidth.smallEditor === true) {
    //     return "reply-editor-container-small";
    //   }
    //   return '';
    // },
    // getReplyClass() {
    //   if (this.editorActiveWidth.fullEditor === true) {
    //     return "reply-container-full";
    //   } else if (this.editorActiveWidth.bigEditor === true) {
    //     return "reply-container-small";
    //   } else if (this.editorActiveWidth.smallEditor === true) {
    //     return "reply-container-big";
    //   }
    //   return '';
    // }
  },

  mounted() {
    this.transferToUsersList = this.FilterNonActiveUsers();
    this.checkIfCreatorConfirmed();
    this.checkIfTaskIsReadOnly();
    this.$emit("taskRepliesForCheck", this.taskRepliesForCheck);
    // this.getTaskUsersTalking();
    // big: this.taskReplies.length > 0 ? true : false,
    // small:false
    // if(this.taskReplies.length == 0){
    //   this.editorActiveWidth.full = true
    //   this.editorActiveWidth.big = false
    //   this.editorActiveWidth.small = false
    // } else{
    //   this.editorActiveWidth.full = false
    //   this.editorActiveWidth.big = true
    //   this.editorActiveWidth.small = false
    // }
    // this.countActiveTasksPerUser()
    // this.countActiveUsersPerGroup();
    // this.$store.dispatch("tasks/fetchAllActiveTasks");
    let tor = () => {
      this.turnOnRec = !this.turnOnRec;
    };
    let x = $(".ql-video");
    let keys = Object.keys(x);
    keys.forEach(e => {
      if (!isNaN(e)) {
        x[e].onclick = event => {
          $(".ql-tooltip").css("display", "none");
          $(".ql-tooltip").on("click", tor());
        };
      }
    });
  },

  watch: {
    assignReplyTo: function() {},
    searchTransferToUserNameQuery: function() {
      this.searchTransferToUserNameQueryResult = this.filterList(
        this.searchTransferToUserNameQuery
      );
      if (this.searchTransferToUserNameQueryResult.length > 1) {
        this.showTransferToUsersResults = true;
      }
      if (this.searchTagQuery === "") {
        this.showTransferToUsersResults = false;
      }
    },
    replyContent: function() {
      this.$emit("setReplyContent", this.replyContent);
    },
    replyUsers: function() {
      // this.$emit("setReplyContent", [this.replyContent]);
    }
  },
  created() {
    //if (this.task.task_type.id === 6) {
    this.getRepliesForCheck();

    //  let body = document.body;
    //  let  html = document.documentElement;
    // }
    // let elem = document.getElementById('reply-window');
    //  let elem =this.$ref['reply-window'].$refs.rootElement.getBoundingClientRect();
    //const elem = document.getElementById(`#replyWindow`)
    // let bounding = elem.getBoundingClientRect();
  },

  updated() {
    this.addOnClickEventForImages();
    if (this.addImgClass !== undefined) {
      this.addImgClass();
    }
    $("div.content-popup-add-reply")
      .find("img")
      .addClass("img-editor");
  },

  methods: {
    containsAlphaNumeric(str) {
      const len = str.length;
      let asciiCode;
      for (let i = 0; i < len; i++) {
        asciiCode = str.charCodeAt(i);
        if ((asciiCode > 47 && asciiCode < 58) || // numeric (0-9)
            (asciiCode > 64 && asciiCode < 91) || // upper alpha (A-Z)
            (asciiCode > 96 && asciiCode < 123)) { // lower alpha (a-z)
          return true;
        }
      }
      return false;
    },
    handleEditorDropdown(type){
      switch (type){
        case '@':
          this.$refs.replyEditor.quill.insertText(0, '@');
          break;
        case '#':
          this.$refs.replyEditor.quill.insertText(0, '#');
          break;
        case 'TXT':
          break;
        default:
          break;
      }
      this.componentKeyReplyEditor++;
      this.$nextTick(() => {
        this.$refs.replyEditor.quill.focus();
        this.$refs.replyEditor.quill.setSelection(1);
      });
    },
    async addNewTagFromEditor(tempTag) {
      let ifCatExists = this.categories.find(category => {
        return category.cat_type == tempTag;
      });

      if (ifCatExists) {
        let newItem = {
          code: ifCatExists,
          value: tempTag
        };
        this.categoriesForMention.push(newItem);
      } else {
        await apiClientCreator(`tasks/category/`)
          .post("", { cat_type: tempTag })
          .then(res => {
            let newItem = {
              code: res.data,
              value: tempTag
            };
            this.categoriesForMention.push(newItem);
          })
          .catch(err => {});
      }
    },

    closeRecDiv() {
      this.$emit("close");
      this.turnOnRec = !this.turnOnRec;
    },
    sendRec(val) {
      this.requestUploadStatusBusy = true;
      let formData = new FormData();
      formData.append("file", val);
      if (val.size <= this.fileMaxSize) {
        this.loaderIsBusy = true;
        apiClientCreator(`tasks/file`)
          .post("", formData)
          .then(result => {
            this.requestUploadStatusBusy = false;

            let url = result.data; // Get url from response
            const vid = `<p><video type="video/mp4" width="240" height="180" controls class="ql-video" src="${url}"></video></p>`;
            $(".ql-editor").append(vid);
            this.theRecoredItSelf = url;
            this.loaderIsBusy = false;
            this.closeRecDiv();
          })
          .catch(err => {});
      } else {
        this.requestUploadStatusBusy = false;

        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: `Error uploading file: Max size 4mb `,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
      }
    },
    textValidation(editorContent) {
      this.badWordsArray.forEach(word => {
        if (editorContent.length > 0) {
          if (editorContent.includes(word)) {
            apiClientCreator(`tasks/bad-word`)
              .post("", {
                user_id: this.auth.user.id,
                word: word,
                task_id: this.task ? this.task.id : null
              })
              .then(res => {})
              .catch(err => {});
            let cleanText = this.badWordsArray.join("|");
            let res = editorContent.replace(
              // new RegExp("\\b(" + cleanText + ")\\b", "gi"),
              new RegExp("(" + cleanText + ")\\b", "gi"),
              " "
            );
            // this.replyTaskTextFromLocal = res;
            this.replyContent = res;

            // subTask.subTaskContent
          }
        }
      });
      this.componentKeyReplyEditor += 1;
      this.$nextTick(() => {
        this.$refs.replyEditor.quill.focus("end");
      });
      this.$nextTick(() => {
        this.$refs.replyEditor.quill.setSelection(editorContent.length, 0);
      });
    },
    showLineThatItHasWaitingCheck() {
      if (this.task.task_check.length > 0) {
        let from = this.task.task_check[0].requested_check;
        let fName = "";
        let tName = "";
        let to = this.task.task_check[0].is_checking;
        this.task.task_assignment.some(t => {
          if (t.assigned_to.id === from) {
            fName = t.assigned_to.full_name;
            tName = t.assigned_by.full_name;
          }
        });
        let display = `On ${this.task.task_check[0].created_at} ${fName} sent to Wating approvel to ${tName}`;
        return display;
      }
    },
    async openMainTaskWindow() {
      await this.$store.dispatch("tasks/fetchAllActiveTasks");

      await this.countActiveTasksPerUser();
      await this.countActiveUsersPerGroup();
      this.replyMode = true;
    },
    countActiveUsersPerGroup() {
      let usersGroups = this.dictionaries.general.roles;
      let tempSalesPerson = this.salesPersonList;
      if (usersGroups !== undefined && tempSalesPerson !== undefined) {
        usersGroups.map(group => {
          let activeUsersPerGroup = [];
          tempSalesPerson.map(user => {
            if (user.role === group.id) {
              activeUsersPerGroup.push(user);
            }
          });
          group.activeUsers = activeUsersPerGroup;
        });
      }
      this.dictionaries.general.roles = usersGroups;
    },
    countActiveTasksPerUser() {
      let tempActiveTasks = this.allActiveTasks.data;
      let tempSalesPerson = this.salesPersonList;
      if (tempActiveTasks !== undefined && tempSalesPerson !== undefined) {
        tempSalesPerson.map(person => {
          let personActiveTasks = [];
          tempActiveTasks.map(task => {
            if (task.user_id === person.id) {
              personActiveTasks.push(task);
            }
          });
          person.countActiveTasks = personActiveTasks.length;
        });
      }
      this.salesPersonList = tempSalesPerson;
    },

    iHaveApproved() {},
    fetchTasks(withStats) {
      let apiClient = apiClientCreator("tasks/list");
      this.$store.commit("clients/setLoading", true);
      const queryParams = this.getQueryParams();
      const tasks = [];

      apiClient
        .get("", { params: queryParams })
        .then(res => {
          res.data.data.forEach(function(data) {
            tasks.push(new TaskModel(data));
          });
          this.getQueryParamsToMs = queryParams;

          if (!withStats) {
            this.updateStats();
          }

          this.tasks = tasks;

          this.pagination.currentPage = res.data.current_page;
          this.pagination.perPage = res.data.per_page;
          this.pagination.from = res.data.from;
          this.pagination.to = res.data.to;
          this.pagination.lastPage = res.data.last_page;
          this.pagination.total = res.data.total;
          this.resetCalendars = false;
          this.resetMultiSelects = false;
          this.sendUpdated = true;
          this.$store.commit("clients/setLoading", false);

          return res;
        })
        .catch(e => {
          this.$store.commit("main/setShowVikiMsg", {
            show: true,
            msg:
              "Connection Error!" + " " + " Error Status: " + e.response.status,
            type: "ERROR",
            op: { type: "SYSTEM" }
          });

          this.$store.commit("clients/setLoading", false);
        });
    },
    getQueryParams() {
      let vm = this;

      let queryParams = {
        page: vm.pagination.currentPage
        // order_by: vm.orderBy,
        // sort_order: vm.sortOrder
      };

      /** Add filters to query */
      for (let key in vm.filters) {
        if (!vm.filters.hasOwnProperty(key)) {
          continue;
        }

        /*        if (key === "task_id") {
                queryParams = {
                  ...queryParams,
                  ...getClientQueryObject(vm.filters[key])
                };
              }*/

        if (vm.filters[key] === null || vm.filters[key] === false) {
          continue;
        }

        // add selectable filters to query

        if (key === "order_by" || key === "sort_order") {
          queryParams[key] = vm.filters[key];
        }
        if (key === "task_id") {
          queryParams[key] = vm.filters[key];
        }

        // add searchable filters to query
        if (
          (key === "email" || key === "loc_phys_ms" || key === "placement") &&
          vm.filters[key].toString().length > 2
        ) {
          queryParams[key] = vm.filters[key];
        }

        if (
          key === "task_types" ||
          key === "task_statuses" ||
          key === "task_priorities" ||
          key === "task_invite_users" ||
          key === "task_users"
        ) {
          let ids = [];

          vm.filters[key].forEach(function(item) {
            ids.push(item.id);
          });

          queryParams[key] = ids;
        }

        /*
              if (key === "registered_on" && vm.filters.registered_on) {
                queryParams.registered_on_from = moment(
                  vm.filters["registered_on"][0]
                ).format("YYYY-MM-DD");
                queryParams.registered_on_to = moment(
                  vm.filters["registered_on"][1]
                ).format("YYYY-MM-DD");
              }
      */

        if (
          key === "active_group" ||
          key === "waiting_group" ||
          key === "meeting_group" ||
          key === "comp_meeting_group" ||
          key === "announce_group" ||
          key === "completed_group" ||
          key === "shift_group" ||
          key === "canceled_group" ||
          key === "progress_group" ||
          key === "future_group" ||
          key === "waiting_approval_group" ||
          key === "show_all_tasks"
        ) {
          queryParams[key] = 1;

          const filterToPush = this.filtersBarArr;
          const filtered = filterToPush.filter(item => item.key !== key);
          const filter_ = {
            text: key,
            stat: "",
            key: key
          };
          this.filtersBarArr = [...filtered, filter_];
        }

        if (key === "countryTime") {
          queryParams["country_time_from"] = vm.filters.countryTime.from;
          queryParams["country_time_to"] = vm.filters.countryTime.to;
        }
      }

      return queryParams;
    },
    checkIfThisTaskIsTransferredToMe() {
      return this.task.transfer.some(
        t => t.transfer_to.id === this.auth.user.id
      );
    },
    checkIfThisTaskIsWaitingToBeChecked() {
      return this.task.task_check.some(
        t => t.is_checking === this.auth.user.id
      );
    },
    checkIfTaskIsReadOnly() {
      let readOnly = this.task.task_read_only.some(
        user => user.user_id === this.auth.user.id
      );
      if (readOnly) {
        this.content = `<p>Read Only </p>`.concat(this.task.content);
      }
    },
    checkIfCreatorConfirmed() {
      let creatorConfirmed = this.task.task_comp_confirmation.some(
        task => task.is_creator === 1 && task.confirmed === 1
      );
      if (creatorConfirmed) {
        this.creatorHasConfirmedTheTask = true;
        this.$emit("creatorHasConfirmedTheTask", true);
      } else {
        this.creatorHasConfirmedTheTask = false;
        this.$emit("creatorHasConfirmedTheTask", false);
      }
    },
    iHaveSeenThatTaskIsConfirmed() {
      this.$store.commit("clients/setLoading", true);

      const addNewClientRequest = apiClientCreator(
        `tasks/confirmTaskCompleted/${this.task.id}`
      );
      addNewClientRequest.post("").then(res => {});
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        msg: "Status changed to completed for you",
        type: "DONE",
        op: { type: "SYSTEM" }
      });
      this.$store.commit("clients/setLoading", false);
      // this.showReplyTaskText = false;
      // this.$emit("updated");
      this.$store.commit("tasks/setFetchTasks", { flag: true });
      this.$emit("clear_sets");
    },
    ConfirmAfterAllReplied() {
      let creator = this.getOriginalCreator();
      let exceptOriginal = this.filterOriginalCreator();
      let whoRepliedWithoutCreator = this.getIdsOfWhoRepliedExceptCreator(
        creator
      );
      exceptOriginal = [...new Set(exceptOriginal)];
      whoRepliedWithoutCreator = [...new Set(whoRepliedWithoutCreator)];
      exceptOriginal.sort((a, b) => a - b);
      whoRepliedWithoutCreator.sort((a, b) => a - b);

      // Check if the arrays are the same length
      if (exceptOriginal.length !== whoRepliedWithoutCreator.length)
        return false;

      for (let i = 0; i < exceptOriginal.length; i++) {
        if (exceptOriginal[i] !== whoRepliedWithoutCreator[i]) return false;
      }
      if (this.auth.user.id !== creator) {
        return false;
      }
      if (this.auth.user.id === creator) {
        return true;
      }
    },

    filterOriginalCreator() {
      let exceptOriginal = this.getAllUsersExceptOriginal(
        this.getOriginalCreator()
      );
      return exceptOriginal;
    },

    getAllUsersExceptOriginal(originalCreator) {
      let assigned_to = [];
      this.task.task_assignment.forEach(assign => {
        assigned_to.push(assign.assigned_to.id);
      });

      let exceptOriginal = assigned_to.filter(item => item !== originalCreator);

      return exceptOriginal;
    },
    getWhoIsChecking() {
      this.task.transfer.forEach(t => {
        if (t.transfer_to.id === this.auth.user.id) {
          this.checkMe(t.transfer_by.id);
        }
      });

      //need to see if more then one transfer, maybe should return this.
      // this.task.task_assignment.some((t) => {
      //     if(t.assigned_by.id === whoTransferred){
      //         this.checkMe(whoTransferred)
      //     }
      // })
    },
    // checkMe(whoTransferred) {
    //   this.$store.commit("clients/setLoading", true);
    //
    //   const addNewClientRequest = apiClientCreator(
    //     `tasks/check/${this.task.id}`
    //   );
    //
    //   const data = {
    //     is_checking: whoTransferred
    //   };
    //   if (this.reply.length > 0) {
    //     Object.assign(data, { reply_content: this.reply });
    //   }
    //
    //   addNewClientRequest.post("", data).then(res => {});
    //   this.$store.commit("main/setShowVikiMsg", {
    //     show: true,
    //     msg: "Sent To Check",
    //     type: "DONE",
    //     op: { type: "SYSTEM" }
    //   });
    //   this.$store.commit("clients/setLoading", false);
    //   this.showReplyTaskText = false;
    //   this.$emit("clear_sets");
    //   //this.$emit("updated");
    //   this.$store.commit("tasks/setFetchTasks", { flag: true });
    // },

    checkAfterApprove() {
      let transferredToMe = this.checkIfThisTaskIsTransferredToMe();
      if (!transferredToMe) {
        let creator = this.getOriginalCreator();
        this.checkMe(creator);
      }
      // this.task.task_check.forEach((t) => {
      //
      //   if(t.is_checking === this.auth.user.id){
      //     this.approveTaskAfterCheck(t.requested_check)
      //   }
      //   }
      // );
    },

    approveTaskAfterCheck(requestedCheck) {
      this.$store.commit("clients/setLoading", true);

      const addNewClientRequest = apiClientCreator(
        `tasks/approveTaskAfterCheck/${task_id}`
      );
      addNewClientRequest
        .post("", {
          user_to_approve: requestedCheck
        })
        .then(res => {});
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        msg: "Task Approved Successfully",
        type: "DONE",
        op: { type: "SYSTEM" }
      });
      this.$store.commit("clients/setLoading", false);
      // this.showReplyTaskText = false;
      this.$emit("clear_sets");
      //this.$emit("updated");
      this.$store.commit("tasks/setFetchTasks", { flag: true });
    },

    getIdsOfWhoRepliedExceptCreator(originalCreator) {
      let WhoRepliedExceptCreator = [];
      this.taskRepliesForCheck.forEach(reply => {
        WhoRepliedExceptCreator.push(reply.user.id);
      });
      let repliesExceptOriginal = WhoRepliedExceptCreator.filter(
        item => item !== originalCreator
      );
      return repliesExceptOriginal;
    },
    getOriginalCreator() {
      let originalCreator = null;
      this.task.task_assignment.forEach(assign => {
        if (assign.assigned_to.id === assign.assigned_by.id) {
          originalCreator = assign.assigned_by.id;
        }
      });

      return originalCreator;
    },

    creatorConfirm(task_id) {
      this.$store.commit("clients/setLoading", true);

      const addNewClientRequest = apiClientCreator(
        `tasks/confirmTaskCompleted/${task_id}`
      );
      addNewClientRequest.post("").then(res => {});
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        msg: "Status changed to completed for you",
        type: "DONE",
        op: { type: "SYSTEM" }
      });
      this.$store.commit("clients/setLoading", false);
      // this.showReplyTaskText = false;
      //  this.$emit("updated");
      this.$store.commit("tasks/setFetchTasks", { flag: true });
      this.$emit("clear_sets");
    },
    filterList(q) {
      function escapeRegExp(s) {
        return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
      }

      const words = q
        .split(/\s+/g)
        .map(s => s.trim())
        .filter(s => !!s);
      const hasTrailingSpace = q.endsWith(" ");
      const searchRegex = new RegExp(
        words
          .map((word, i) => {
            if (i + 1 === words.length && !hasTrailingSpace) {
              // The last word - ok with the word being "startswith"-like
              return `(?=.*\\b${escapeRegExp(word)})`;
            } else {
              // Not the last word - expect the whole word exactly
              return `(?=.*\\b${escapeRegExp(word)}\\b)`;
            }
          })
          .join("") + ".+",
        "gi"
      );
      return this.salesPersonList.filter(item => {
        return searchRegex.test(item.full_name);
      });
    },
    showTransferToBox() {
      this.transferTaskTo = !this.transferTaskTo;

      if (this.transferTaskTo) {
        this.transferToButtonText = "Cancel Transfer To user";
      } else {
        this.transferToButtonText = "TRANSFER TASK TO";
        this.transferToThisUser = [];
      }
    },
    confirmUser(task) {
      try {
        this.$store.commit("clients/setLoading", true);

        const addNewClientRequest = apiClientCreator(`tasks/confirmEndTask`);
        addNewClientRequest
          .post("", {
            user_id: task.reply_by,
            task_id: task.task_id
          })
          .then(res => {
            this.waitingToBeConfirmed = res.data;
            this.getReplies();
            //  this.$emit("updated");
            this.$store.commit("tasks/setFetchTasks", { flag: true });
          });
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "User Confirmed Successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "There was a problem with confirmation",
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },

    replyToSpecificUser(id) {
      let userInArray = this.replyToSpecificUsers.includes(id);
      if (userInArray) {
        let index = this.replyToSpecificUsers.indexOf(id);
        this.replyToSpecificUsers.splice(index, 1);
        let elementId = `selectUser-${id}`;
        let target = document.getElementById(elementId);
        target.classList.toggle("select-user");
      }

      if (!userInArray) {
        this.replyToSpecificUsers.push(id);
        let elementId = `selectUser-${id}`;
        let target = document.getElementById(elementId);
        target.classList.toggle("select-user");
      }
    },

    paginate(arr, page_number, page_size) {
      return arr.slice((page_number - 1) * page_size, page_number * page_size);
    },
    onRepliesClick() {
      if (!this.editorActiveWidth.smallEditor) {
        this.flag += 1;
        this.editorActiveWidth.smallEditor = true;
        this.editorActiveWidth.bigEditor = false;
        this.editorActiveWidth.fullEditor = false;
      }
    },
    onEditorFocus() {
      if (
        !this.editorActiveWidth.bigEditor &&
        !this.editorActiveWidth.fullEditor
      ) {
        this.flag += 1;
        this.editorActiveWidth.smallEditor = false;
        if (this.editorActiveWidth.fullEditor !== true) {
          this.editorActiveWidth.bigEditor = true;
        }
        this.$nextTick(() => {
          this.$refs.replyEditor.quill.focus("end");
        });
        this.$nextTick(() => {
          this.$refs.replyEditor.quill.setSelection(
            this.replyContent.length,
            0
          );
        });
      }
    },
    onEditorBlur(quill) {
      // this.newTask.showNewTaskTextEditor = false;
    },
    outClose() {
      // this.showReplyTaskText = false;
      this.$emit("clear_sets");

      //
      // if(this.showReplyTaskText){
      //   $("#close-reply-editor-modal").modal();
      //   // $(".modal-backdrop.in").hide();
      //
      // }
    },
    closeEditorFromModal() {
      // this.showReplyTaskText = false;
      this.transferTaskTo = false;
      this.$emit("clear_sets");
    },
    checkUserConfirmation() {
      const found = this.taskRepliesForCheck.find(
        item => item.reply_by === this.auth.user.id
      );
      return found === undefined;
    },
    checkOwnership() {
      let arr = [];
      for (let i = 0; i < this.task.task_assignment.length; i++) {
        arr.push(this.task.task_assignment[i].assigned_by.id);
      }
      let creators = [...new Set(arr)];

      return creators.includes(this.auth.user.id);
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },

    removeHtml(tag) {
      return tag.replace(/<\/?[^>]+(>|$)/g, " ");
    },

    async updateDueDate() {
      try {
        this.$store.commit("clients/setLoading", true);
        const addNewClientRequest = apiClientCreator(
          `tasks/update/due/${this.task.id}`
        );
        await addNewClientRequest.put("", {
          due_date: moment().add("hours", "25")
        });
        //  this.$emit("updated");
        this.$store.commit("tasks/setFetchTasks", { flag: true });
        // this.showReplyTaskText = false;
        this.transferTaskTo = false;
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Task priority updated successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Error task priority update " +
            " " +
            " Error Status: " +
            e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },

    async updateTaskStatus(statusId) {
      try {
        this.$store.commit("clients/setLoading", true);
        const addNewClientRequest = apiClientCreator(
          `tasks/update/status/${this.task.id}`
        );
        await addNewClientRequest.put("", { status_id: statusId });
        //this.$emit("updated");
        this.$store.commit("tasks/setFetchTasks", { flag: true });

        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Task status updated successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Error task status update " +
            " " +
            " Error Status: " +
            e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },

    async getReplies() {
      try {
        // //    this.$store.commit("clients/setLoading", true);
        // const addNewClientRequest = apiClientCreator(
        //   `tasks/reply/${this.task.id}`
        // );
        // const response = await addNewClientRequest.get("");

        // this.taskReplies = response.data;
        this.taskReplies = this.task.reply;
        if (this.taskReplies.length == 0) {
          this.editorActiveWidth.fullEditor = true;
          this.editorActiveWidth.bigEditor = false;
          this.editorActiveWidth.smallEditor = false;
        } else {
          this.editorActiveWidth.fullEditor = false;
          this.editorActiveWidth.bigEditor = true;
          this.editorActiveWidth.smallEditor = false;
        }
        // this.showReplyPopup = true;
        //this.$emit("updated");
        this.reply = null;
        //    this.$store.commit("clients/setLoading", false);
      } catch (e) {
        /*        this.$store.commit("main/setShowVikiMsg", {
                                      show: true,
                                      msg:
                                        "Error task reply fetch " +
                                        " " +
                                        " Error Status: " +
                                        e.response.status,
                                      type: "ERROR"
                                    });*/
        //   this.$store.commit("clients/setLoading", false);
      }
    },

    async getRepliesForCheck() {
      //   this.$emit("show_assign_inp", this.task);
      try {
        // this.$store.commit("clients/setLoading", true);
        // const addNewClientRequest = apiClientCreator(
        //   `tasks/reply/${this.task.id}`
        // );
        // const response = await addNewClientRequest.get("");
        this.taskRepliesForCheck = this.task.reply;

        //    this.$emit("updated");

        //  this.$store.commit("clients/setLoading", false);
      } catch (e) {
        /* this.$store.commit("main/setShowVikiMsg", {
                                      show: true,
                                      msg:
                                              "Error task reply fetch " +
                                              " " +
                                              " Error Status: " +
                                              e.response.status,
                                      type: "ERROR"
                                    });
                                    this.$store.commit("clients/setLoading", false);*/
      }
    },

    async updateTaskContent() {
      try {
        this.$store.commit("clients/setLoading", true);
        const UpdateTaskRequest = apiClientCreator(
          `tasks/update/content/${this.task.id}`
        );
        await UpdateTaskRequest.put("", { content: this.content });

        // this.$emit("updated");
        this.$store.commit("tasks/setFetchTasks", { flag: true });
        // this.showEditTaskText = false;
        // this.showPencil = false;
        this.inEditTaskOperation = false;
        this.reply = "";
        this.content = this.task.content;
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Task replied successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });

        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Error task reply " + " " + " Error Status: " + e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },

    async replyTask() {
      try {
        this.$store.commit("clients/setLoading", true);
        const addNewClientRequest = apiClientCreator(
          `tasks/reply/${this.task.id}`
        );

        // let ids = [];

        // if (this.replyToSpecificUsers.length > 0) {
        //   ids = this.replyToSpecificUsers;
        // } else {
        //   this.assignReplyTo.forEach(function(item) {
        //     ids.push(item.id);
        //   });
        // }
        // if(this.replyContent.length < 1){
        //   let errMsg = "Please input message"
        //   throw errMsg;
        // }

        if (this.replyUsers.length < 1) {
          let errMsg = "Please select user to reply";
          throw errMsg;
        }
        // this.replyUsers.push(this.auth.user.id)
        let replyUsersArray = [];
        replyUsersArray.push(this.auth.user.id);
        replyUsersArray.push(this.replyUsers[0].id);
        await addNewClientRequest
          .post("", {
            reply_categories: this.replyCategories,
            reply_content: this.replyContent,
            // reply_content: this.reply,
            // reply_content: this.content,
            // assign_to: ids,
            // assign_to: this.replyUsers,
            assign_to: replyUsersArray,
            status_id: this.replyStatus.id,
            not_approved_rating: this.notApprovedStarRating
          })
          .then(res => {
            this.$emit("clear_sets");
            this.$store.commit("tasks/setFetchTasks", { flag: true });
            // this.$root.$emit("change_tab_to_waiting");
          });
        this.$root.$emit("task_replied", this.task.id);

        const socketData = {
          assign_to: [replyUsersArray[1]],
          assigned_by: replyUsersArray[0],
          message: "New Task Reply",
          type: "TASK",
          options: {
            msg_type: "REP",
            date: moment().toDate(),
            task_id: this.task.id
          }
        };
        this.msgSocket.emit("user_task_assignment", socketData);

        // this.showReplyTaskText = false;
        this.transferTaskTo = false;
        this.reply = null;
        localStorage.removeItem("taskText");
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Task replied successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);

        // if(this.transferToThisUser.length > 0){
        //     await this.setTaskTransfer()
        // }
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            // "Error task reply " + " " + " Error Status: " + e.response.status,
            "Error task reply " + " " + " Error Status: " + e,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },
    async setTaskTransfer() {
      let apiClient = apiClientCreator(`tasks/transfer_task/${this.task.id}`);
      let transferToIds = [];
      this.transferToThisUser.forEach(user => {
        transferToIds.push(user.id);
      });
      await apiClient
        .post("", { transfer_to: transferToIds })
        .then(res => {
          // this.showReplyTaskText = false;
          this.transferToThisUser = [];
          this.transferTaskTo = false;
          this.searchTransferToUserNameQueryResult = [];
          this.$emit("clear_sets");
          //  this.$emit("updated");
          this.$store.commit("tasks/setFetchTasks", { flag: true });
        })
        .catch(e => {
          this.$store.commit("main/setShowVikiMsg", {
            show: true,
            msg:
              "Connection Error!" + " " + " Error Status: " + e.response.status,
            type: "ERROR",
            op: { type: "SYSTEM" }
          });

          this.$store.commit("clients/setLoading", false);
        });
    },

    async replyConfirmTask() {
      try {
        this.$store.commit("clients/setLoading", true);
        const addNewClientRequest = apiClientCreator(
          `tasks/reply_confirm/${this.task.id}`
        );
        await addNewClientRequest.post("", {
          reply_content: "I Have Read It",
          assign_to: [this.task.task_assignment[0].assigned_by.id]
        });

        await this.getRepliesForCheck();
        //  this.$emit("updated");
        this.$store.commit("tasks/setFetchTasks", { flag: true });
        // this.showReplyTaskText = false;
        this.transferTaskTo = false;

        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Task replied successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Error task reply " + " " + " Error Status: " + e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },
    async replyCloseTask() {
      try {
        this.$store.commit("clients/setLoading", true);
        const request = apiClientCreator(`tasks/reply_close/${this.task.id}`);
        let ids = [];
        this.assignReplyTo.forEach(function(item) {
          ids.push(item.id);
        });

        await request.post("", {
          reply_content: this.reply,
          assign_to: ids
        });
        await this.getRepliesForCheck();
        // this.$emit("updated");
        this.$store.commit("tasks/setFetchTasks", { flag: true });
        // this.showReplyTaskText = false;
        this.transferTaskTo = false;

        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Task replied successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Error task reply " + " " + " Error Status: " + e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },

    async replyEndTask() {
      try {
        this.$store.commit("clients/setLoading", true);
        const request = apiClientCreator(`tasks/reply_end/${this.task.id}`);
        let ids = [];
        this.assignReplyTo.forEach(function(item) {
          ids.push(item.id);
        });

        await request.post("", {
          reply_content: this.reply,
          assign_to: ids
        });

        await this.getRepliesForCheck();
        //  this.$emit("updated");
        this.$store.commit("tasks/setFetchTasks", { flag: true });
        // this.showReplyTaskText = false;
        this.transferTaskTo = false;
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Task replied successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Error task reply " + " " + " Error Status: " + e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },
    async updateReply() {
      try {
        this.$store.commit("clients/setLoading", true);
        const UpdateReplyRequest = apiClientCreator(
          `tasks/reply/${this.selectedReplyIdToUpdate}`
        );
        await UpdateReplyRequest.put("", { new_content: this.replyContent });
        // await UpdateReplyRequest.put("", { new_content: this.reply });

        this.inEditReplyOperation = false;
        this.selectedReplyIdToUpdate = null;
        this.reply = "";
        await this.getReplies();
        //   this.$emit("updated");
        this.$store.commit("tasks/setFetchTasks", { flag: true });
        // this.showReplyTaskText = false;
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Reply updated successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Error while updating reply  " +
            " " +
            " Error Status: " +
            e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },

    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      this.requestUploadStatusBusy = true;
      if (file.size <= this.fileMaxSize) {
        if (file.type.indexOf("image") != -1) {
          let formData = new FormData();
          formData.append("image", file);
          apiClientCreator(`tasks/image`)
            .post("", formData)
            .then(result => {
              this.requestUploadStatusBusy = false;

              let url = result.data; // Get url from response

              Editor.insertEmbed(cursorLocation, "image", url);
              resetUploader();
              // let editors = document.getElementsByClassName("reply-container")
              let images = document
                .getElementsByClassName("reply-editor-container-full")[0]
                .getElementsByTagName("IMG");
              // let images = document
              //   .getElementsByClassName("ql-editor")[1]
              //   .getElementsByTagName("IMG");
              images.forEach(img => {
                img.setAttribute("class", "img-editor");
                img.onclick = function() {
                  let modal = document.getElementById("imgModalReply");
                  let modalImg = document.getElementById("imgReply");
                  modal.style.display = "block";
                  modalImg.src = this.src;
                  let span = document.getElementsByClassName("close-img-modal");
                  for (let item of span) {
                    item.onclick = function() {
                      // $("#imgModalReply").modal("hide")
                      modal.style.display = "none";
                    };
                  }

                  // let modal = document.getElementById("imgModalReply");
                  // let modalImg = document.getElementById("imgReply");
                  // modal.style.display = "block";
                  // modalImg.src = this.src;
                  // let span = document.getElementsByClassName(
                  //   "close-img-modal"
                  // )[0];
                  //
                  // span.onclick = function() {
                  //   modal.style.display = "none";
                  // };
                };
              });
            })
            .catch(err => {});
        } else if (
          file.type.indexOf("pdf") != -1 ||
          file.type.indexOf("doc") != -1 ||
          file.type.indexOf("docx") != -1 ||
          file.type.indexOf("txt") != -1 ||
          file.type.indexOf("text") != -1 ||
          file.type == "" // NEED TO AVOID UPLOADING ALL TYPES OF FILES
        ) {
          let formData = new FormData();
          formData.append("file", file);

          apiClientCreator(`tasks/file`)
            .post("", formData)
            .then(result => {
              this.requestUploadStatusBusy = false;

              let url =
                "https://docs.google.com/viewer?url=" +
                result.data +
                "&embedded=true"; // Get url from response
              Editor.insertEmbed(
                cursorLocation,
                "video",
                url,
                "100",
                "100",
                "1"
              );
              let files = document.getElementsByTagName("IFRAME");
              files.forEach(file => {
                file.setAttribute("frameborder", "1");
                file.setAttribute("height", "320");
              });

              resetUploader();
            })
            .catch(err => {});
        } else if (file.type.indexOf("video") != -1) {
          // .insertEmbed(cursorLocation, "image", url);
          // Editor.clipboard.dangerouslyPasteHTML(5, `&nbsp;<video type="video/mp4" width="320" height="240" controls class="ql-video"src="https://crm-toolstrades.s3.eu-central-1.amazonaws.com/user_files/1597400214blob"></video>`);
          // '&nbsp;<video width="320" height="240" controls>\n' +
          // '  <source src="https://www.w3schools.com/tags/movie.mp4" type="video/mp4">\n' +
          // '  Your browser does not support the video tag.\n' +
          // '</video>'
        }
      } else {
        this.requestUploadStatusBusy = false;

        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: `Error uploading file: Max size 4mb `,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
      }
    },
    addOnClickEventForImages() {
      let images = document.getElementsByClassName("img-editor");

      images.forEach(img => {
        img.setAttribute("class", "img-editor");
        img.onclick = function() {
          let modal = document.getElementById("imgModalReply");
          let modalImg = document.getElementById("imgReply");
          // $("#imgModalReply").modal();
          modal.style.display = "block";

          modalImg.src = this.src;
          let span = document.getElementsByClassName("close-img-modal");
          for (let item of span) {
            item.onclick = function() {
              // $("#imgModalReply").modal("hide")
              modal.style.display = "none";
            };
          }

          // let modal = document.getElementById("imgModalReply");
          // let modalImg = document.getElementById("imgReply");
          // modal.style.display = "block";
          // modalImg.src = this.src;
          // // Get the <span> element that closes the modal
          // let span = document.getElementsByClassName("close-img-modal")[0];
          //
          // // When the user clicks on <span> (x), close the modal
          // span.onclick = function() {
          //   modal.style.display = "none";
          // };
        };
      });
      /*          .catch(err => {
                        });*/
      // } else if (file.type == "") {
    },
    renewTaskWithNewUser() {},
    addImgClass() {
      // let flag = document.getElementsByClassName("ql-editor")[0]
      if (document.getElementsByClassName("ql-editor")[0] != undefined) {
        let images = document
          .getElementsByClassName("ql-editor")[0]
          .getElementsByTagName("IMG");

        images.forEach(img => {
          img.setAttribute("class", "img-editor");
          img.onclick = function() {
            let modal = document.getElementById("imgModalReply");
            let modalImg = document.getElementById("imgReply");
            // $("#imgModalReply").modal();
            modal.style.display = "block";

            modalImg.src = this.src;
            let span = document.getElementsByClassName("close-img-modal");
            for (let item of span) {
              item.onclick = function() {
                // $("#imgModalReply").modal("hide")
                modal.style.display = "none";
              };
            }

            // let modal = document.getElementById("imgModalReply");
            // let modalImg = document.getElementById("imgReply");
            // modal.style.display = "block";
            // modalImg.src = this.src;
            // // Get the <span> element that closes the modal
            // let span = document.getElementsByClassName("close-img-modal")[0];
            // span.onclick = function() {
            //   modal.style.display = "none";
            // };
          };
        });
      }
    },
    closeMainTaskWindow() {
      if (
        event.target.className == "v-cal-dialog-card__header" ||
        event.target.className == "v-cal-dialog__title" ||
        event.target.className == "v-cal-input" ||
        event.target.className == "v-cal-input " ||
        event.target.className == "v-cal-input-group" ||
        event.target.className == "v-cal-dialog-card__footer" ||
        event.target.className == "v-cal-dialog__close" ||
        event.target.className == "v-cal-dialog__bg" ||
        event.target.className == "v-cal-button is-rounded is-primary" ||
        event.target.className == "v-cal-dialog-card__body" ||
        event.target.className == "v-cal-fields" ||
        event.target.className == "v-cal-label" ||
        event.target.className == "form-control" ||
        event.target.className == "select-option" ||
        event.target.className == "vue__time-picker time-picker" ||
        event.target.className == "display-time all-selected" ||
        event.target.className == "dropdown" ||
        event.target.className == "clear-btn" ||
        event.target.className == "select-list" ||
        event.target.className == "hours" ||
        event.target.className == "minutes" ||
        event.target.className == "time-picker-overlay" ||
        event.target.className == "custom-select" ||
        event.target.className == "option" ||
        event.target.className == "active" ||
        event.target.className == ""
      ) {
      } else {
        this.replyMode = false;
      }
    },
    getUserReplyTo(replyTo) {
      let userTo = " ";
      this.assignReplyTo.forEach(user => {
        if (user.id !== replyTo) {
          userTo += user.full_name;
        }
      });
      return userTo;
    },
    getTimeReply(time) {
      // let duration = moment.duration(moment(this.task.created_at).diff(time));
      let duration = moment.duration(moment(time).diff(this.task.created_at));
      // let hours = duration.asHours();
      let hours = duration.humanize();
      return hours;
    }
  },

  // async setTaskTransfer() {
  //   let apiClient = apiClientCreator(
  //     `tasks/transfer_task/${this.tasks[this.tasks.length - 1].id}`
  //   );
  //   let transferToIds = [];
  //   this.transferToThisUser.forEach(user => {
  //     transferToIds.push(user.id);
  //   });
  //   await apiClient
  //     .post("", { transfer_to: transferToIds })
  //     .then(res => {
  //       this.searchTransferToUserNameQueryResult = [];
  //     })
  //     .catch(e => {
  //       this.$store.commit("main/setShowVikiMsg", {
  //         show: true,
  //         msg:
  //           "Connection Error!" + " " + " Error Status: " + e.response.status,
  //         type: "ERROR",
  //         op: { type: "SYSTEM" }
  //       });
  //
  //       this.$store.commit("clients/setLoading", false);
  //     });
  // },
  beforeMount() {
    this.getReplies();
  }
};
</script>

<style scoped>
.popup-content {
  padding: 10px;
  position: absolute;
  top: 24px;
  right: 10px;
  z-index: 10001;
  width: max-content;
  background-color: #fff;
  border: solid 1px #90a4ae;
  border-radius: 5px;

  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.table-responsive {
  height: 100%;
  margin-bottom: 0px;
  border-radius: 5px;
}

.content-root {
  font-family: "Montserrat";
  position: relative;
  text-align: left;
}

.content-root-left {
  position: relative;
  text-align: left;
}

.btn-finish {
  padding: 3px;
  border: none;
  border-radius: 3px;
  font-size: 8pt;
  background: #4caf50;
  color: white;
  margin: 2px;
}

.btn-finish:hover {
  background: #9e9e9e;
}

.btn-cancel {
  padding: 3px;
  border: none;
  border-radius: 3px;
  font-size: 8pt;
  background: #f44336;
  color: white;
  margin: 2px;
}

.btn-cancel:hover {
  background: #9e9e9e;
}

.btn-reply {
  padding: 3px;
  height: 20px;
  line-height: 10px;
  font-size: 8pt;
  margin-left: 5px;
}

.btn-reply-hover {
  background: #9e9e9e;
}

.btn-in-progress {
  padding: 3px;
  border: none;
  border-radius: 3px;
  font-size: 8pt;
  background: #7b1fa2;
  color: white;
  margin: 2px;
}

.btn-in-progress:hover {
  background: #9e9e9e;
}

.new-client-cancel-btn {
  color: red !important;
  margin-left: 5px;
  margin-top: 5px;
}

.new-client-ok-btn {
  color: green !important;
  position: absolute;
  right: 20px;
  bottom: 5px;
}

.edit-text-cancel-btn {
  color: red !important;
  position: absolute;
  right: 10px;
  bottom: 5px;
}

.edit-text-ok-btn {
  color: green !important;
  position: absolute;
  right: 25px;
  bottom: 5px;
}

.edit-reply-cancel-btn {
  color: red !important;
  position: absolute;
  right: 30px;
  bottom: 5px;
}

.edit-reply-ok-btn {
  color: green !important;
  position: absolute;
  right: 45px;
  bottom: 5px;
}

.btns-div {
  position: absolute;
  top: 0px;
  right: -14px;
  padding: 0px;
  display: flex;
}

.input-standard {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 36px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  box-sizing: border-box;
}

.edit-pencil {
  cursor: pointer;
}

.reply-input-box {
}

.input-box-reply {
  position: absolute;
  top: -323px;
  /*bottom: -509px;*/
  right: -350px;
  z-index: 10001;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  width: 180%;
  height: auto;
  padding: 10px 10px 28px 10px;
  background-color: #fff;
  /*height: 647px;*/
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  overflow: hidden;
}

.tag-table {
  position: absolute;
  top: 24px;
  right: 0px;
  z-index: 10001;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  width: max-content;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.reply-table {
  position: absolute;
  top: 35px;
  right: -140px;
  z-index: 10001;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  width: 130%;

  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.reply-table-inner {
  height: auto;
  overflow-x: hidden;
  max-height: 250px;
  font-size: 9pt;
}
/*.reply-table-inner-top {*/
/*  height: 30%;*/
/*  overflow-y: scroll;*/
/*}*/
.reply-editor-container-full {
  height: 100%;
  /*overflow-y: scroll;*/
}
.reply-editor-container-small {
  height: 20%;
  overflow-y: scroll;
}
.reply-editor-container-big {
  height: 80%;
  overflow-y: scroll;
}
.reply-container-big {
  height: 80%;
  overflow-y: scroll;
}
.reply-container-small {
  /*height: 20%;*/
  height: 18%;
  overflow-y: scroll;
}

.reply-table-inner-bottom {
  height: 20%;
}
.reply-table-bottom {
  position: absolute;
  top: 135px;
  right: 0px;
  z-index: 10001;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  width: 100%;

  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.input-box {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 10001;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  width: 100%;
  padding: 10px 10px 28px 10px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.content-popup {
  position: absolute;
  bottom: 35px;
  right: 0px;
  z-index: 10001;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  width: 100%;
  padding: 10px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.content-popup-add-reply {
  height: 200px;
  overflow-x: hidden;
  overflow-y: scroll;

  margin-bottom: 5px;

  border: 1px solid #c4c4c4;
  padding: 10px;
  background: #fafafa;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
}

.reply-assignments {
  font-size: 9pt;
  height: auto;
  max-height: 80px;
  width: 100px;
  overflow-x: hidden;
}

.reply-content-td {
  /*width: 690px;*/
}

.reply-content {
  font-size: 9pt;
  height: auto;
  /*max-height: 140px;*/
  /*width: 740px;*/
  overflow-x: hidden;

  word-break: break-all;
  white-space: normal;
}

.reply-date-time {
  text-align: center;
  font-size: 9pt;
}

.reply-user-name {
  /*text-align: center;*/
  font-size: 9pt;
  min-width: 100px;
}

.content-small {
  font-size: 10pt;
  max-height: 60px;
  width: 100%;
  overflow-x: hidden;
}

.btn-reply-box {
  /*    padding: 3px;
                  height: 20px;
                  line-height: 10px;
                  font-size: 8pt;
                  margin-left: 5px;*/

  margin-top: 3px;
  margin-bottom: 3px;
  white-space: nowrap;
  cursor: pointer;
  vertical-align: middle;
  padding: 2px;
  text-align: center;
  background: #fafafa;
  line-height: 1;
  font-size: 10pt;
  border: 1px solid transparent;
  transition: box-shadow 0.2s ease-in-out, border 0.2s ease-in-out;
  -webkit-appearance: none;
}

.btn-reply-box:hover {
  background: #44a2d2;
  color: white;
}

.btn-reply-box-cancel-btn {
  color: red !important;
  float: right;
  margin-right: 5px;
  margin-top: 2px;
  /* position: absolute;
                   right: 10px;
                   bottom: 5px;*/
}

.div-btn-reply-box {
  margin-top: 5px;
  margin-bottom: 5px;
  border: 1px solid #c4c4c4;
  padding-left: 3px;
  background: #fafafa;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}

.reply-table-inner td {
  border-top: 1px solid #dee2e6;
}

.toolbar-separator {
  border-left: 1px solid #c4c4c4;
  border-bottom: 1px solid #c4c4c4;
  margin-top: 0;
  margin-right: 2px;
  margin-left: 2px;
}

.task-menu-btn {
  font-size: 13pt;
  height: 23px;
  font-weight: lighter;
  cursor: pointer;
  vertical-align: middle;
  color: #2c4762;
  background: white;
  border: 1px solid #c4c4c4;
  border-radius: 4px;
  transition: background 0.2s ease, color 0.2s ease;
}

.task-menu-btn:hover {
  color: white;
  background: #44a2d2;
}

.task-menu-btn-hover {
  font-size: 12pt;
  cursor: pointer;
  vertical-align: middle;
  color: white;
  background: #44a2d2;
  border: 1px solid #c4c4c4;
  border-radius: 4px;
  transition: background 0.2s ease, color 0.2s ease;
}

.read-it-btn {
  fill: #2c4762;
  cursor: pointer;
  margin-right: 3px;
  transition: background 0.2s ease, color 0.2s ease;
  vertical-align: middle;
}

.read-it-btn:hover {
  fill: #44a2d2;
  margin-right: 3px;
}

.edit-menu {
  background-color: #f1f1f1;
}

.dropdown-menu {
  width: max-content;
  min-width: 80px !important;
  padding: 2px;
  border: 1px solid #c4c4c4;
}

.edit-menu button {
  display: block;
  font-size: 8pt;
  font-weight: bold;
  background-color: white;
  color: #2c4762;
  width: 100%;
  height: 20px;
  outline: none;
  text-align: center;
  cursor: pointer;
  transition: 0.2s;
  line-height: 8pt;
  border: none;
}

/* Change background color of buttons on hover */

/* Create an active/current "tab button" class */
/*
          .edit-menu button.active {
            border-bottom: 2px solid #44a2d2 !important;
            background: #44a2d2;
            color: white;
            width: 105%;
            border-bottom-right-radius: 5px;
            border-top-right-radius: 5px;
          }
          */

.edit-menu button:hover {
  background: #44a2d2;
  color: white;
}

.edit-reply-btn-div {
  display: flex;
  vertical-align: center;
}

.edit-reply-btn-edit {
  margin-right: 25px;

  cursor: pointer;
}

#reply-editor {
  background-color: red !important;
  height: 300px !important;
}

.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 2222222222222222222222222222222; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add Animation */
.modal-content,
#caption {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0);
  }
  to {
    -webkit-transform: scale(1);
  }
}

@keyframes zoom {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

/* The Close Button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-content {
    width: 100%;
  }
}

span.togglebutton {
  position: absolute;
  left: 0;
  top: 0;
  background-color: black;
  padding: 3px;
  color: white;
  font-size: 50px;
  z-index: 5555555555555555555555555555555555555555;
}

.waitingToBeConfirmed {
  background-color: #ff8c68;
}

.select-user {
  background-color: #5da4db;
}

.transfer-to-users-box {
  position: absolute;
  top: 361px;
  right: 170px;
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.stay-open-transfer {
  overflow-y: scroll;
  display: block !important;
  max-height: 343px;
  top: -101px;
  position: absolute;
  left: -43px;
  width: 200px;
  padding: 10px;
}

.pointer {
  cursor: pointer;
}

.input-main {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: border-box;
}

.item-text {
  margin-left: 5px;
}

.m-b-3px {
  margin-bottom: 3px;
}
#main-task-window {
  position: absolute;
  height: 884px;
  z-index: 1;
  top: -318px;
  left: -462px;
  width: 1801px;
  background-color: #f7f7f7;
  border-radius: 5px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.07),
    0 4px 8px rgba(0, 0, 0, 0.07), 0 8px 16px rgba(0, 0, 0, 0.07),
    0 16px 32px rgba(0, 0, 0, 0.07), 0 32px 64px rgba(0, 0, 0, 0.07);
}
.reply-container {
  height: 100%;
}
.reply-table-first {
  width: 100%;
}
#t-body {
  width: 200px;
}
.user-img {
  height: 30px;
  width: 30px;
}

td.reply-content-td div.reply-content {
  display: inline-block;
  clear: both;
  padding: 10px 10px 0px;
  border-radius: 30px;
  margin-bottom: 2px;
  font-family: Helvetica, Arial, sans-serif;
}

.him {
  background: #eee;
  float: left;
}

.me {
  float: right;
  background: #0084ff;
  color: #fff;
}

.him + .me {
  border-bottom-right-radius: 5px;
}

.me + .me {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.me:last-of-type {
  border-bottom-right-radius: 30px;
}
thead {
  font-size: 12px;
  padding: 5px;
}
td {
  font-size: 12px;
  /*padding-left: 5px;*/
  padding: 5px;
}
.replies-table {
  width: 100%;
}

/*#reply-editor.ql-editor {*/
/*  min-height: 20%;*/
/*  background-color: red !important;*/
/*}*/
.table-bordered > thead > tr > td,
.table-bordered > thead > tr > th {
  border-bottom-width: 2px;
  padding: 4px;
}
/*ul[data-checked="false"] > li::before {*/
/*  content: '\2E3A';*/
/*  font-size: 1.5rem;*/
/*}*/

/*ul[data-checked="true"] li::before {*/
/*  content: '\2713';*/
/*  font-size: 1.5rem;*/
/*}*/
/*.td-content ul[data-checked="true"]{*/
/*  text-decoration: line-through;*/
/*  color: red;*/
/*}*/
/*.td-content ul[data-checked="false"]{*/
/*  text-decoration: line-through;*/

/*  color: #0fb97b;*/
/* }*/
/*ul{*/
/*  color: aqua!important;*/
/*}*/
/*  p>img{*/
/*    height: 100px!important;*/
/*  }*/
.tab-pane.active,
.tab-pane.tab-pane-editor {
  /*height: 570px;*/
  height: 100%;
}
.forRec {
  left: 546px !important;
  position: absolute !important;
  top: 715px !important;
  z-index: 100000 !important;
}
.myVideo-dimensions {
  width: 128px !important;
  height: 120px !important;
}
.task-content-preview {
  position: absolute;
  left: 941px;
  top: 243px;
  border-radius: 3px;
  border: 1px solid #f6f4f3;
  border-top-color: #fff;
  /*background-color: #ebe8e5;*/
  background-color: #fff;
  padding: 18px;
  -webkit-box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.15);
  overflow: auto;
  width: 797px;
  height: 592px;
}
/*div#reply-editor {*/
/*    height: 560px!important;*/
/*}*/
</style>
